import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { films } from "@/mocks/films";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4">
      {categories.map((category) => {
        const count = films.filter((film) => film.categories.includes(category.key)).length;
        return (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group relative block h-32 cursor-pointer overflow-hidden rounded-lg md:h-36"
          >
            <img
              src={category.image}
              alt={`${category.name}三级片分类配图`}
              title={`${category.name}三级片电影大全`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-primary-950/10" />
            <div className="absolute inset-0 flex flex-col justify-end p-3 md:p-4">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">
                  {category.name}片
                </h3>
                <span className="flex items-center gap-1 rounded-full bg-background-50/15 px-2 py-0.5 text-[10px] text-background-100">
                  {count} 部
                </span>
              </div>
              <p className="mt-1 hidden text-[11px] leading-relaxed text-background-300 sm:block">
                {category.short}
              </p>
              <span className="mt-2 flex items-center gap-1 text-[11px] text-secondary-300 opacity-0 transition-opacity group-hover:opacity-100">
                进入分类
                <i className="ri-arrow-right-s-line" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}